import { Action } from '../core/action'
import { Value } from '../core/state'

export const i18n = {
  // State
  locale: new Value<string>('en'),

  // Actions
  getTranslationMessages: new Action<
    [
      args: {
        locale: string
        options?: {
          phrases?: string[]
        }
      }
    ],
    Record<string, string> | undefined
  >(),
} as const
